module.exports = __webpack_public_path__ + "static/media/hero-retina.69849dd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/dashboard/hero-retina.jpg
// module id = 375
// module chunks = 0